/* SANGAHZ logo recolor preview.
   Takes an existing product photo, finds the printed logo (the ink that stands out
   from the garment), and repaints it in the chosen logo color. Used when there is
   no real photo of the exact garment color + logo + logo color combination. */
(function () {
  if (window.SZRecolor) return;

  var REGIONS = {
    garment: { rx0: 0.15, rx1: 0.85, ry0: 0.10, ry1: 0.72 },
    hat: { rx0: 0.15, rx1: 0.85, ry0: 0.10, ry1: 0.55 }
  };
  var MIN_SPAN = 38;
  var spanCache = {};
  var outCache = {};

  function fileName(u) { return String(u || '').split('/files/').pop().split('?')[0]; }

  function load(name) {
    return new Promise(function (resolve, reject) {
      var im = new Image();
      im.onload = function () { resolve(im); };
      im.onerror = reject;
      im.src = '/cdn/shop/files/' + name + '?width=900';
    });
  }

  function analyze(im, region) {
    var W = im.naturalWidth, H = im.naturalHeight;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(im, 0, 0);
    var d = ctx.getImageData(0, 0, W, H), p = d.data, N = W * H;
    var lum = new Float32Array(N), bg = new Uint8Array(N), seen = new Uint8Array(N);
    for (var i = 0; i < N; i++) lum[i] = 0.299 * p[i * 4] + 0.587 * p[i * 4 + 1] + 0.114 * p[i * 4 + 2];
    function isBg(i) {
      var r = p[i * 4], g = p[i * 4 + 1], b = p[i * 4 + 2], a = p[i * 4 + 3];
      if (a < 20) return true;
      var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
      return mn > 228 && mx - mn < 18;
    }
    // Background = near-white/transparent pixels connected to the image border.
    var stack = [], X, Y;
    for (X = 0; X < W; X++) { stack.push(X, (H - 1) * W + X); }
    for (Y = 0; Y < H; Y++) { stack.push(Y * W, Y * W + W - 1); }
    while (stack.length) {
      var k = stack.pop();
      if (seen[k]) continue;
      seen[k] = 1;
      if (!isBg(k)) continue;
      bg[k] = 1;
      X = k % W; Y = (k / W) | 0;
      if (X > 0) stack.push(k - 1);
      if (X < W - 1) stack.push(k + 1);
      if (Y > 0) stack.push(k - W);
      if (Y < H - 1) stack.push(k + W);
    }
    var x0 = W, x1 = 0, y0 = H, y1 = 0;
    for (i = 0; i < N; i++) if (!bg[i]) {
      X = i % W; Y = (i / W) | 0;
      if (X < x0) x0 = X; if (X > x1) x1 = X; if (Y < y0) y0 = Y; if (Y > y1) y1 = Y;
    }
    var gw = x1 - x0, gh = y1 - y0;
    var R = {
      x0: (x0 + gw * region.rx0) | 0, x1: (x0 + gw * region.rx1) | 0,
      y0: (y0 + gh * region.ry0) | 0, y1: (y0 + gh * region.ry1) | 0
    };
    var vals = [];
    for (Y = R.y0; Y < R.y1; Y += 2) for (X = R.x0; X < R.x1; X += 2) { i = Y * W + X; if (!bg[i]) vals.push(lum[i]); }
    if (vals.length < 50) return null;
    vals.sort(function (a, b) { return a - b; });
    var base = vals[(vals.length / 2) | 0];
    var lo = vals[(vals.length * 0.03) | 0], hi = vals[(vals.length * 0.97) | 0];
    var ink = (base - lo) > (hi - base) ? lo : hi;
    return { canvas: c, ctx: ctx, img: d, lum: lum, bg: bg, W: W, H: H, R: R, gw: gw, gy0: y0, gh: gh, base: base, ink: ink, span: Math.abs(ink - base) };
  }

  function inkT(a, i) { return (a.lum[i] - a.base) / (a.ink - a.base); }

  // Bounding box of the printed logo (robust to stray pixels).
  function logoBox(a) {
    var xs = [], ys = [], R = a.R, W = a.W;
    for (var Y = R.y0; Y < R.y1; Y++) for (var X = R.x0; X < R.x1; X++) {
      var i = Y * W + X;
      if (!a.bg[i] && inkT(a, i) >= 0.6) { xs.push(X); ys.push(Y); }
    }
    if (xs.length < 40) return null;
    xs.sort(function (p, q) { return p - q; }); ys.sort(function (p, q) { return p - q; });
    var lo = (xs.length * 0.005) | 0, hi = (xs.length * 0.995) | 0;
    var b = { x0: xs[lo], x1: xs[hi], y0: ys[lo], y1: ys[hi] };
    b.w = b.x1 - b.x0 + 1; b.h = b.y1 - b.y0 + 1;
    return b;
  }

  function paint(a, hex) {
    var p = a.img.data, W = a.W, R = a.R;
    var tr = parseInt(hex.slice(1, 3), 16), tg = parseInt(hex.slice(3, 5), 16), tb = parseInt(hex.slice(5, 7), 16);
    var den = a.ink - a.base;
    for (var Y = R.y0; Y < R.y1; Y++) for (var X = R.x0; X < R.x1; X++) {
      var i = Y * W + X;
      if (a.bg[i]) continue;
      var t = (a.lum[i] - a.base) / den;
      if (t < 0.45) continue;
      var m = Math.min(1, (t - 0.45) / 0.35), k = 4 * i;
      p[k] = p[k] * (1 - m) + tr * m;
      p[k + 1] = p[k + 1] * (1 - m) + tg * m;
      p[k + 2] = p[k + 2] * (1 - m) + tb * m;
    }
    a.ctx.putImageData(a.img, 0, 0);
    try { return a.canvas.toDataURL('image/webp', 0.9); } catch (e) { return null; }
  }

  async function spanOf(name, regionKey) {
    var key = name + '|' + regionKey;
    if (key in spanCache) return spanCache[key];
    try {
      var a = analyze(await load(name), REGIONS[regionKey]);
      spanCache[key] = a ? a.span : 0;
    } catch (e) { spanCache[key] = 0; }
    return spanCache[key];
  }

  /* candidates: photo URLs of the same garment color + logo (any logo color).
     Returns a data URL of the clearest one with its logo repainted, or null. */
  async function render(candidates, hex, regionKey) {
    regionKey = REGIONS[regionKey] ? regionKey : 'garment';
    var names = [];
    (candidates || []).forEach(function (u) { var n = fileName(u); if (n && names.indexOf(n) < 0) names.push(n); });
    if (!names.length || !/^#[0-9a-fA-F]{6}$/.test(hex)) return null;
    var bestName = null, bestSpan = 0;
    for (var j = 0; j < names.length; j++) {
      var s = await spanOf(names[j], regionKey);
      if (s > bestSpan) { bestSpan = s; bestName = names[j]; }
    }
    if (!bestName || bestSpan < MIN_SPAN) return null;
    var key = bestName + '|' + hex + '|' + regionKey;
    if (outCache[key]) return outCache[key];
    try {
      var a = analyze(await load(bestName), REGIONS[regionKey]);
      if (!a) return null;
      outCache[key] = paint(a, hex);
      return outCache[key];
    } catch (e) { return null; }
  }

  /* Box around the printed logo: the densest band of ink rows (small gaps
     bridged so a tagline under the logo stays with it), then the densest
     band of ink columns inside it. Acid-wash speckle and folds are too
     sparse to win. cx = garment center on the logo's middle row. */
  function findLogo(a, gapX) {
    var R = a.R, W = a.W, X, Y, i;
    function band(arr, gap) {
      var n = arr.length, sm = new Float32Array(n), mx = 0, at = 0, q;
      for (q = 0; q < n; q++) {
        var s = 0, c = 0;
        for (var d = -3; d <= 3; d++) if (q + d >= 0 && q + d < n) { s += arr[q + d]; c++; }
        sm[q] = s / c; if (sm[q] > mx) { mx = sm[q]; at = q; }
      }
      var lim = mx * 0.12, lo = at, hi = at, miss = 0;
      for (q = at; q >= 0; q--) { if (sm[q] >= lim) { lo = q; miss = 0; } else if (++miss > gap) break; }
      miss = 0;
      for (q = at; q < n; q++) { if (sm[q] >= lim) { hi = q; miss = 0; } else if (++miss > gap) break; }
      return [lo, hi, mx];
    }
    var rows = [];
    for (Y = R.y0; Y < R.y1; Y++) {
      var c = 0;
      for (X = R.x0; X < R.x1; X++) { i = Y * W + X; if (!a.bg[i] && inkT(a, i) >= 0.6) c++; }
      rows.push(c);
    }
    var rb = band(rows, 26);
    if (rb[2] < 4) return null;
    var y0 = R.y0 + rb[0], y1 = R.y0 + rb[1], cols = [];
    for (X = R.x0; X < R.x1; X++) {
      var c2 = 0;
      for (Y = y0; Y <= y1; Y++) { i = Y * W + X; if (!a.bg[i] && inkT(a, i) >= 0.6) c2++; }
      cols.push(c2);
    }
    var cb = band(cols, gapX || 18);
    var x0 = R.x0 + cb[0], x1 = R.x0 + cb[1];
    var mid = ((y0 + y1) / 2) | 0, gl = -1, gr = -1;
    for (X = 0; X < W; X++) if (!a.bg[mid * W + X]) { if (gl < 0) gl = X; gr = X; }
    return { x0: x0, x1: x1, y0: y0, y1: y1, w: x1 - x0 + 1, h: y1 - y0 + 1, cx: (gl + gr) / 2 };
  }

  var boxCache = {};
  async function logoInfo(name, regionKey) {
    var key = name + '|' + regionKey;
    if (key in boxCache) return boxCache[key];
    try {
      var a = analyze(await load(name), REGIONS[regionKey]);
      var b = a && findLogo(a, regionKey === 'hat' ? 40 : 18);
      boxCache[key] = b ? { rel: b.w / a.gw } : null;
    } catch (e) { boxCache[key] = null; }
    return boxCache[key];
  }

  /* Put a different logo on a garment photo: erase the logo that is printed
     there, then stamp the wanted logo (lifted from a donor photo) in hex. */
  async function compose(baseName, baseLogoDonor, donorName, hex, regionKey) {
    var region = REGIONS[regionKey];
    var A = analyze(await load(baseName), region);
    var D = analyze(await load(donorName), region);
    if (!A || !D) return null;
    var cap = regionKey === 'hat';
    // Arched cap lettering has wide gaps between letters; bridge them.
    var ob = findLogo(A, cap ? 40 : 18), db = findLogo(D, cap ? 40 : 18);
    if (!ob || !db) return null;
    // A logo found up in the hood/crown is a misread; let the caller try another photo.
    if ((ob.y0 + ob.y1) / 2 < A.gy0 + A.gh * 0.22) return null;
    // Size: keep the ratio between the two logos as they print. A base photo
    // whose logo has no donor (a custom design) keeps the same width.
    var relNew = await logoInfo(donorName, regionKey);
    var relOld = baseLogoDonor ? await logoInfo(baseLogoDonor, regionKey) : relNew;
    if (!relNew || !relOld) return null;
    var p = A.img.data, W = A.W, H = A.H, i, X, Y, k;

    // 1. Erase the old logo: ink pixels in its box (grown 2px) take the fabric
    //    from the same column just above or below, so folds and acid-wash
    //    texture carry across.
    var pad = cap ? 18 : 10;
    var bx0 = Math.max(0, ob.x0 - pad), bx1 = Math.min(W - 1, ob.x1 + pad);
    var by0 = Math.max(0, ob.y0 - pad), by1 = Math.min(H - 1, ob.y1 + pad);
    var mask = new Uint8Array(W * H);
    for (Y = by0; Y <= by1; Y++) for (X = bx0; X <= bx1; X++) {
      i = Y * W + X;
      if (!A.bg[i] && inkT(A, i) >= 0.25) {
        for (var oy = -2; oy <= 2; oy++) for (var ox = -2; ox <= 2; ox++) {
          var yy = Y + oy, xx = X + ox;
          if (yy >= 0 && yy < H && xx >= 0 && xx < W) mask[yy * W + xx] = 1;
        }
      }
    }
    if (regionKey === 'hat') {
      // Caps: the crown is smooth, so each masked run in a row is filled by
      // blending the clean fabric just left and right of it.
      var clean = function (j) { return !A.bg[j] && !mask[j] && inkT(A, j) < 0.25; };
      for (Y = Math.max(0, by0 - 2); Y <= Math.min(H - 1, by1 + 2); Y++) {
        for (X = Math.max(0, bx0 - 2); X <= Math.min(W - 1, bx1 + 2); X++) {
          i = Y * W + X;
          if (!mask[i] || A.bg[i]) continue;
          var xb = X;
          while (xb + 1 < W && mask[Y * W + xb + 1] && !A.bg[Y * W + xb + 1]) xb++;
          var L = -1, Rr = -1, q;
          for (q = X - 1; q >= Math.max(0, X - 60); q--) if (clean(Y * W + q)) { L = Y * W + q; break; }
          for (q = xb + 1; q <= Math.min(W - 1, xb + 60); q++) if (clean(Y * W + q)) { Rr = Y * W + q; break; }
          if (L < 0 && Rr < 0) { X = xb; continue; }
          if (L < 0) L = Rr; if (Rr < 0) Rr = L;
          for (var x2 = X; x2 <= xb; x2++) {
            var f = xb > X ? (x2 - X) / (xb - X) : 0.5;
            k = (Y * W + x2) * 4;
            p[k] = p[L * 4] * (1 - f) + p[Rr * 4] * f;
            p[k + 1] = p[L * 4 + 1] * (1 - f) + p[Rr * 4 + 1] * f;
            p[k + 2] = p[L * 4 + 2] * (1 - f) + p[Rr * 4 + 2] * f;
          }
          X = xb;
        }
      }
    } else {
    var off = by1 - by0 + 6, seed = 12345;
    var rnd = function () { seed = (seed * 1103515245 + 12345) & 0x7fffffff; return seed / 0x7fffffff; };
    for (Y = by0 - 2; Y <= by1 + 2; Y++) for (X = bx0 - 2; X <= bx1 + 2; X++) {
      if (Y < 0 || Y >= H || X < 0 || X >= W) continue;
      i = Y * W + X;
      if (!mask[i] || A.bg[i]) continue;
      var src = -1;
      for (var t = 0; t < 16 && src < 0; t++) {
        var jx = X + ((rnd() * 9) | 0) - 4, dir = t % 2 ? 1 : -1, mul = 1 + ((t / 4) | 0) * 0.4;
        var jy = Y + dir * Math.round(off * mul) + ((rnd() * 5) | 0) - 2;
        if (jx < 0 || jx >= W || jy < 0 || jy >= H) continue;
        var j = jy * W + jx;
        if (!A.bg[j] && !mask[j] && inkT(A, j) < 0.25) src = j;
      }
      if (src < 0) continue;
      k = i * 4; src *= 4;
      p[k] = p[src]; p[k + 1] = p[src + 1]; p[k + 2] = p[src + 2];
    }
    }

    // 2. Stamp the new logo, sized like it prints relative to the old one,
    //    centered on the garment where the old logo sat.
    // Caps come in different shapes, so size from the donor's share of the cap.
    var newW = cap ? relNew.rel * A.gw : Math.min(ob.w * (relNew.rel / relOld.rel), A.gw * 0.6);
    var s = newW / db.w, newH = db.h * s;
    var left = ob.cx - newW / 2, top = (ob.y0 + ob.y1) / 2 - newH / 2;
    var tr = parseInt(hex.slice(1, 3), 16), tg = parseInt(hex.slice(3, 5), 16), tb = parseInt(hex.slice(5, 7), 16);
    for (Y = Math.max(0, top | 0); Y < Math.min(H, top + newH); Y++) {
      for (X = Math.max(0, left | 0); X < Math.min(W, left + newW); X++) {
        i = Y * W + X;
        if (A.bg[i]) continue;
        var sx = Math.round(db.x0 + (X - left) / s), sy = Math.round(db.y0 + (Y - top) / s);
        if (sx < 0 || sy < 0 || sx >= D.W || sy >= D.H) continue;
        var si = sy * D.W + sx;
        if (D.bg[si]) continue;
        var m = (inkT(D, si) - 0.45) / 0.35;
        if (m <= 0) continue;
        if (m > 1) m = 1;
        k = i * 4;
        p[k] = p[k] * (1 - m) + tr * m; p[k + 1] = p[k + 1] * (1 - m) + tg * m; p[k + 2] = p[k + 2] * (1 - m) + tb * m;
      }
    }
    A.ctx.putImageData(A.img, 0, 0);
    try { return A.canvas.toDataURL('image/webp', 0.9); } catch (e) { return null; }
  }

  /* cfg: { photos: [[file, color, logo], ...], donors: { logo: file } }
     Returns { url, kind } where kind is 'recolor' (a photo of this logo exists)
     or 'compose' (logo moved onto this garment from another photo), or null. */
  async function preview(cfg, color, logo, hex, regionKey) {
    regionKey = REGIONS[regionKey] ? regionKey : 'garment';
    if (!cfg || !cfg.photos || !/^#[0-9a-fA-F]{6}$/.test(hex)) return null;
    var same = cfg.photos.filter(function (r) { return r[1] === color && r[2] === logo; }).map(function (r) { return r[0]; });
    if (same.length) {
      var u = await render(same, hex, regionKey);
      if (u) return { url: u, kind: 'recolor' };
    }
    var donor = cfg.donors && cfg.donors[logo];
    if (!donor) return null;
    var bases = cfg.photos.filter(function (r) { return r[1] === color && cfg.donors[r[2]]; });
    // No photo of this color with a known logo: use any photo of the color.
    if (!bases.length) bases = cfg.photos.filter(function (r) { return r[1] === color; });
    var scored = [];
    for (var j = 0; j < bases.length; j++) {
      var sp = await spanOf(bases[j][0], regionKey);
      if (sp >= 25) scored.push([sp, bases[j]]);  // erasing needs less contrast than recoloring
    }
    scored.sort(function (x, y) { return y[0] - x[0]; });
    for (var n = 0; n < scored.length; n++) {
      var best = scored[n][1];
      var key = 'c|' + best[0] + '|' + donor + '|' + hex + '|' + regionKey;
      if (outCache[key]) return { url: outCache[key], kind: 'compose' };
      try {
        var url = await compose(best[0], cfg.donors[best[2]] || null, donor, hex, regionKey);
        if (url) { outCache[key] = url; return { url: url, kind: 'compose' }; }
      } catch (e) {}
    }
    return null;
  }

  window.SZRecolor = { render: render, preview: preview, compose: compose, _i: { load: load, analyze: analyze, findLogo: findLogo, inkT: inkT, spanOf: spanOf, REGIONS: REGIONS } };
})();
